import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import './permisssion';
import 'font-awesome/css/font-awesome.min.css';
import './assets/style/iconfont/iconfont.css';
import './assets/style/reset.css';
import './assets/style/public.css';
import './assets/style/el.css';
import './assets/style/common.scss';

Vue.config.productionTip = false;

// 引入全局组件
import HeaderContainer from './components/HeaderContainer';
Vue.component('HeaderContainer', HeaderContainer);
import ContainerBodyHead from './components/ContainerBodyHead';
Vue.component('ContainerBodyHead', ContainerBodyHead);
import ContainerBodyForm from './components/ContainerBodyForm';
Vue.component('ContainerBodyForm', ContainerBodyForm);
import ContainerBodyFoot from './components/ContainerBodyFoot';
Vue.component('ContainerBodyFoot', ContainerBodyFoot);
import Pagination from './components/Pagination';
Vue.component('Pagination', Pagination);
import TagTitle from './components/TagTitle';
Vue.component('TagTitle', TagTitle);
import ProgressState from './components/ProgressState';
Vue.component('ProgressState', ProgressState);
import RadioGroup from './components/RadioGroup';
Vue.component('RadioGroup', RadioGroup);
import CheckboxGroup from './components/CheckboxGroup';
Vue.component('CheckboxGroup', CheckboxGroup);

// 引入element框架
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
// Vue.use(ElementUI, { size: 'small' });
Vue.use(ElementUI);

// import echarts from 'echarts';
// Vue.prototype.$echarts = echarts;

new Vue({ router, store, render: h => h(App) }).$mount('#app');
